import React, { useSyncExternalStore } from 'react';

import { ClearOutlined } from '@mui/icons-material';
import { Alert, type AlertColor, IconButton, Snackbar, Typography } from '@mui/material';
import createFastStore from '@wp-react/store/createFastStore';

type TState = {
  snackbarMessage: JSX.Element | null;
};
const STORE = createFastStore<TState>({ snackbarMessage: null });

export function useSnackBarMessage() {
  return useSyncExternalStore(STORE.subscribe, () => STORE.get().snackbarMessage);
}

export const alertSuccess = (message: string | JSX.Element) => pushSnackbarStringAlert('success', message);
export const alertError = (message: string | JSX.Element) => pushSnackbarStringAlert('error', message);
export const alertInfo = (message: string | JSX.Element) => pushSnackbarStringAlert('info', message);

const pushSnackbarStringAlert = (severity: AlertColor, message: string | JSX.Element) => {
  let body = message;
  if (typeof body === 'string') {
    body = <Typography fontWeight="fontWeightMedium">{body}</Typography>;
  }
  STORE.set({
    snackbarMessage: (
      <SnackbarMessage key={new Date().toISOString()} severity={severity}>
        {message}
      </SnackbarMessage>
    ),
  });
};

export const removeSnackbarAlert = () => {
  STORE.set({ snackbarMessage: null });
};

type Props = {
  children: JSX.Element | string;
  severity: AlertColor;
};
function SnackbarMessage({ children, severity }: Props) {
  return (
    <Snackbar
      open
      onClose={removeSnackbarAlert}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      action={[
        <IconButton aria-label="close" color="inherit" onClick={removeSnackbarAlert} size="small">
          <ClearOutlined />
        </IconButton>,
      ]}
    >
      <Alert
        onClose={removeSnackbarAlert}
        variant="filled"
        severity={severity}
        elevation={10}
        sx={{ alignItems: 'center' }}
      >
        {children}
      </Alert>
    </Snackbar>
  );
}
